import { FC } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AvatarIcon } from '../../../_core/constants/icons.constants';

interface UnrecognizedFamilyDetailsProps {
	fullName: string;
	phoneNumber: string;
}

export const UnrecognizedFamilyDetails: FC<UnrecognizedFamilyDetailsProps> = ({ fullName, phoneNumber }) => {
	const [t] = useTranslation();

	return (
		<Container
			maxWidth={false}
			sx={{ display: 'flex', flexDirection: 'column', height: '100%', paddingBottom: '16px', '&.MuiContainer-root': { paddingX: 0 } }}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%' }}>
				<Box
					sx={{
						flexGrow: 1,
						padding: 1,
						display: 'flex',
						gap: 3,
                        alignItems: 'center'
					}}
				>
					<Box
						style={{
							width: 98,
							height: 98,
							borderRadius: '32px',
							backgroundColor: 'var(--blue-8-opacity, rgba(36, 57, 106, 0.08))',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<AvatarIcon />
					</Box>

					<Box>
						<Typography variant="body2" sx={{ fontWeight: 'regular', color: (theme) => theme.colors.grayBlue }}>
							{t('families.columns.full-name')}
						</Typography>
						<Typography sx={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							{fullName}
						</Typography>{' '}
					</Box>

					<Box>
						<Typography variant="body2" sx={{ fontWeight: 'regular', color: (theme) => theme.colors.grayBlue }}>
							{t('families.columns.phone-number')}
						</Typography>
						<Typography sx={{ fontWeight: 'bold' }}>{phoneNumber}</Typography>
					</Box>
				</Box>
			</Box>
		</Container>
	);
};
